import React from 'react'
import PropTypes from 'prop-types'

export default class StaffBlockoutDateRange extends React.Component {
  static propTypes = {
    event: PropTypes.shape({
      title: PropTypes.string.isRequired,
      attributes: PropTypes.shape({
        userId: PropTypes.number.isRequired
      }).isRequired
    }).isRequired
  }

  render() {
    const { event } = this.props

    return (
      <a
        href={`/admin/users/${event.attributes.userId}/availability`}
        className="calendar-event">
        { event.title }
      </a>
    )
  }
}

